import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import LocationsHeroSection from './components/LocationsHeroSection';
import LocationsOverviewSection from './components/LocationsOverviewSection';
import KagoshimaLocationSection from './components/KagoshimaLocationSection';
import KawasoeLocationSection from './components/KawasoeLocationSection';
import SagaLocationSection from './components/SagaLocationSection';

export default function LocationsPage() {
  useEffect(() => {
    // Set page title
    document.title = '3拠点一覧｜IDS佐賀・川副・鹿児島教習所｜アクセス・連絡先｜IDS教習所グループ';

    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'IDS教習所グループの3拠点（IDS佐賀教習所・IDS川副教習所・IDS鹿児島教習所）のアクセス・連絡先情報。佐賀県多久市（株式会社アイテム・0952-71-9855）、佐賀県佐賀市（九三エンジニアリング株式会社・0952-97-5291）、鹿児島県日置市（株式会社エコナーセリー・099-213-9466）。農業ドローン・自動操舵システム・水管理システムの販売・サポート・点検整備・散布代行・資格取得まで地域密着対応。平日9:00〜17:00受付。');
    }

    // Set meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'IDS教習所グループ,IDS佐賀教習所,IDS川副教習所,IDS鹿児島教習所,株式会社アイテム,九三エンジニアリング株式会社,株式会社エコナーセリー,佐賀県,多久市,佐賀市,川副町,鹿児島県,日置市,伊集院町,アクセス,連絡先,営業時間,農業ドローン,自動操舵システム,水管理システム,ドローンスクール,地域密着,点検整備,散布代行');
    }

    // Set canonical URL
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', 'https://ids-group.jp/locations');
    }

    // Set OG tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', '3拠点一覧｜IDS佐賀・川副・鹿児島教習所｜アクセス・連絡先｜IDS教習所グループ');
    }

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'IDS教習所グループの3拠点（IDS佐賀教習所・IDS川副教習所・IDS鹿児島教習所）のアクセス・連絡先情報。佐賀県多久市（株式会社アイテム・0952-71-9855）、佐賀県佐賀市（九三エンジニアリング株式会社・0952-97-5291）、鹿児島県日置市（株式会社エコナーセリー・099-213-9466）。農業ドローン・自動操舵システム・水管理システムの販売・サポート・点検整備・散布代行・資格取得まで地域密着対応。平日9:00〜17:00受付。');
    }

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('href', 'https://ids-group.jp/locations');
    }

    // Add ItemList JSON-LD schema
    const itemListSchema = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      "name": "IDS教習所グループ 拠点一覧",
      "description": "佐賀・鹿児島3拠点で農業ドローン・自動操舵システムを包括サポート",
      "itemListElement": [
        {
          "@type": "LocalBusiness",
          "name": "IDS佐賀教習所",
          "description": "佐賀拠点本部。RTK基地局無償提供、DJI推薦修理センター認定、農業ドローン協議会認定スクール運営。",
          "url": "https://ids-group.jp/locations#saga",
          "telephone": "+81952719855",
          "email": "info@ids-group.jp",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "北多久町大字小侍4771",
            "addressLocality": "多久市",
            "addressRegion": "佐賀県",
            "postalCode": "846-0002",
            "addressCountry": "JP"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 33.2895,
            "longitude": 130.1127
          },
          "openingHoursSpecification": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            "opens": "09:00",
            "closes": "17:00"
          },
          "areaServed": "佐賀県西部・中山間地域",
          "parentOrganization": {
            "@type": "Organization",
            "name": "株式会社アイテム"
          },
          "hasMap": "https://www.google.com/maps?q=33.2895,130.1127",
          "priceRange": "$$",
          "makesOffer": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "RTK基地局無償提供",
                "serviceType": "測位支援サービス"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "農業ドローンスクール",
                "serviceType": "技能講習"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "請負散布業",
                "serviceType": "代行作業"
              }
            }
          ]
        },
        {
          "@type": "LocalBusiness",
          "name": "IDS川副教習所",
          "description": "佐賀拠点。RTK基地局無償提供、DJI認定整備士在籍、請負散布(Hacchi Drone Works)対応。",
          "url": "https://ids-group.jp/locations#kawasoe",
          "telephone": "+81952975291",
          "email": "info@ids-group.jp",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "川副町小々森146-1",
            "addressLocality": "佐賀市",
            "addressRegion": "佐賀県",
            "postalCode": "840-2213",
            "addressCountry": "JP"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 33.2235,
            "longitude": 130.3358
          },
          "openingHoursSpecification": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            "opens": "09:00",
            "closes": "17:00"
          },
          "areaServed": "佐賀県東部・福岡県南部",
          "parentOrganization": {
            "@type": "Organization",
            "name": "九三エンジニアリング株式会社"
          },
          "hasMap": "https://www.google.com/maps?q=33.2235,130.3358",
          "priceRange": "$$",
          "makesOffer": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "RTK基地局無償提供",
                "serviceType": "測位支援サービス"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "請負散布(Hacchi Drone Works)",
                "serviceType": "代行作業"
              }
            }
          ]
        },
        {
          "@type": "LocalBusiness",
          "name": "IDS鹿児島教習所",
          "description": "鹿児島拠点。DJI認定整備士在籍、鹿児島県内スマート農業強力サポート、請負散布対応。",
          "url": "https://ids-group.jp/locations#kagoshima",
          "telephone": "+81992139466",
          "email": "info@ids-group.jp",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "伊集院町古城795",
            "addressLocality": "日置市",
            "addressRegion": "鹿児島県",
            "postalCode": "899-2504",
            "addressCountry": "JP"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 31.6275,
            "longitude": 130.3985
          },
          "openingHoursSpecification": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            "opens": "09:00",
            "closes": "17:00"
          },
          "areaServed": "鹿児島県全域",
          "parentOrganization": {
            "@type": "Organization",
            "name": "株式会社エコナーセリー"
          },
          "hasMap": "https://www.google.com/maps?q=31.6275,130.3985",
          "priceRange": "$$",
          "makesOffer": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "農業ドローンスクール",
                "serviceType": "技能講習"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "請負散布業",
                "serviceType": "代行作業"
              }
            }
          ]
        }
      ]
    };

    const scriptTag = document.createElement('script');
    scriptTag.type = 'application/ld+json';
    scriptTag.text = JSON.stringify(itemListSchema);
    document.head.appendChild(scriptTag);

    // Add BreadcrumbList JSON-LD schema
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "ホーム",
          "item": "https://ids-group.jp/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "拠点一覧",
          "item": "https://ids-group.jp/locations"
        }
      ]
    };

    const breadcrumbScriptTag = document.createElement('script');
    breadcrumbScriptTag.type = 'application/ld+json';
    breadcrumbScriptTag.text = JSON.stringify(breadcrumbSchema);
    document.head.appendChild(breadcrumbScriptTag);

    return () => {
      document.head.removeChild(scriptTag);
      document.head.removeChild(breadcrumbScriptTag);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <LocationsHeroSection />
        <LocationsOverviewSection />
        <SagaLocationSection />
        <KawasoeLocationSection />
        <KagoshimaLocationSection />
      </main>
      <Footer />
    </div>
  );
}
